import { BooleanTextPipe } from './booleanText.pipe';
import { CapitalizePipe } from './capitalize.pipe';
import { DecodeUrlPipe } from './decodeUrl.pipe';
import { getFormattedDate } from './getFormattedDate.pipe';
import { GetValuePipe } from './getValue.pipe';
import { LightenDarkenColorPipe } from './lightenDarken.pipe';
import { OrderByPipe } from './orderBy.pipe';
import { PrepareForPrimeNgTranslation } from './prepareForPrimeNGTranslation.pipe';
import { RemoveEmptyPipe } from './removeEmpty.pipe';
import { SecureResourceUrlPipe } from './secureResourceUrl.pipe';
import { SecureUrlPipe } from './secureUrl.pipe';
import { TruncateTextPipe } from './truncateText.pipe';

export const Pipes = [
  GetValuePipe,
  RemoveEmptyPipe,
  LightenDarkenColorPipe,
  getFormattedDate,
  DecodeUrlPipe,
  OrderByPipe,
  BooleanTextPipe,
  SecureUrlPipe,
  SecureResourceUrlPipe,
  CapitalizePipe,
  TruncateTextPipe,
  PrepareForPrimeNgTranslation
];
